export default "__VITE_ASSET__CQiuyR3y__"